module.exports = __webpack_public_path__ + "static/img/ent-41.e699605.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-41.jpg
// module id = XWer
// module chunks = 51